/**
 * CLIENTELE – Collection Page JS
 * Phase 3: Client-side filtering, sidebar toggle, sort redirect, JS filter
 */

(function () {
  'use strict';

  /* ── STATE ────────────────────────────────────────────────────────────── */
  const state = {
    availability: [],   // 'in-stock' | 'sold-out'
    tags: [],
    vendors: [],
    dropLabels: [],
    priceMin: null,
    priceMax: null,
  };

  /* ── ELEMENTS ─────────────────────────────────────────────────────────── */
  const sidebar       = document.getElementById('cl-sidebar');
  const backdrop      = document.getElementById('cl-sidebar-backdrop');
  const filterToggle  = document.getElementById('cl-filter-toggle');
  const sidebarClose  = document.getElementById('cl-sidebar-close');
  const sortSelect    = document.getElementById('cl-sort-select');
  const grid          = document.getElementById('cl-product-grid');
  const priceMin      = document.getElementById('cl-price-min');
  const priceMax      = document.getElementById('cl-price-max');
  const priceApply    = document.getElementById('cl-price-apply');

  if (!sidebar || !grid) return;

  /* ── SIDEBAR TOGGLE ───────────────────────────────────────────────────── */
  function openSidebar() {
    sidebar.classList.add('is-open');
    backdrop.classList.add('is-visible');
    filterToggle && (filterToggle.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    sidebar.classList.remove('is-open');
    backdrop.classList.remove('is-visible');
    filterToggle && (filterToggle.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
  }

  filterToggle && filterToggle.addEventListener('click', () => {
    const isOpen = filterToggle.getAttribute('aria-expanded') === 'true';
    isOpen ? closeSidebar() : openSidebar();
  });

  sidebarClose && sidebarClose.addEventListener('click', closeSidebar);
  backdrop && backdrop.addEventListener('click', closeSidebar);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sidebar.classList.contains('is-open')) closeSidebar();
  });

  /* ── FILTER GROUP ACCORDION ───────────────────────────────────────────── */
  document.querySelectorAll('[data-filter-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const body = btn.nextElementSibling;
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (body) {
        if (expanded) {
          body.setAttribute('hidden', '');
        } else {
          body.removeAttribute('hidden');
        }
      }
    });
  });

  /* ── SORT SELECT ──────────────────────────────────────────────────────── */
  sortSelect && sortSelect.addEventListener('change', () => {
    const val = sortSelect.value;
    // 'clientele-featured' = our custom Liquid sort, remove sort_by param
    const url = new URL(window.location.href);
    if (val === 'clientele-featured') {
      url.searchParams.delete('sort_by');
    } else {
      url.searchParams.set('sort_by', val);
    }
    url.searchParams.delete('page'); // reset pagination
    window.location.assign(url.toString());
  });

  /* ── CHECKBOXES ───────────────────────────────────────────────────────── */
  document.querySelectorAll('.cl-filter-check').forEach((cb) => {
    cb.addEventListener('change', () => {
      syncState();
      applyFilters();
    });
  });

  /* ── PRICE ────────────────────────────────────────────────────────────── */
  priceApply && priceApply.addEventListener('click', () => {
    state.priceMin = priceMin && priceMin.value !== '' ? parseFloat(priceMin.value) * 100 : null;
    state.priceMax = priceMax && priceMax.value !== '' ? parseFloat(priceMax.value) * 100 : null;
    applyFilters();
  });

  /* ── SYNC STATE FROM DOM ──────────────────────────────────────────────── */
  function syncState() {
    state.availability = [];
    state.tags = [];
    state.vendors = [];
    state.dropLabels = [];

    document.querySelectorAll('.cl-filter-check:checked').forEach((cb) => {
      const type = cb.dataset.filterType;
      const val  = cb.value;
      if (type === 'availability') state.availability.push(val);
      if (type === 'tag')          state.tags.push(val);
      if (type === 'vendor')       state.vendors.push(val);
      if (type === 'drop_label')   state.dropLabels.push(val);
    });
  }

  /* ── APPLY FILTERS ────────────────────────────────────────────────────── */
  function applyFilters() {
    const cards = grid.querySelectorAll('.cl-card');
    let visibleCount = 0;

    cards.forEach((card) => {
      const available   = card.dataset.available === 'true';
      const stock       = parseInt(card.dataset.stock, 10) || 0;
      const vendor      = card.dataset.vendor || '';
      const dropLabel   = card.dataset.dropLabel || '';
      const price       = parseInt(card.dataset.price, 10) || 0;

      let show = true;

      /* availability filter */
      if (state.availability.length) {
        const wantInStock  = state.availability.includes('in-stock');
        const wantSoldOut  = state.availability.includes('sold-out');
        if (wantInStock && !wantSoldOut && !available) show = false;
        if (wantSoldOut && !wantInStock && available)  show = false;
      }

      /* vendor filter */
      if (show && state.vendors.length) {
        if (!state.vendors.includes(vendor)) show = false;
      }

      /* drop_label filter */
      if (show && state.dropLabels.length) {
        if (!state.dropLabels.includes(dropLabel)) show = false;
      }

      /* price range filter (price is in cents) */
      if (show && state.priceMin !== null && price < state.priceMin) show = false;
      if (show && state.priceMax !== null && price > state.priceMax) show = false;

      card.classList.toggle('is-hidden', !show);
      if (show) visibleCount++;
    });

    /* update count */
    const countEl = document.querySelector('.cl-collection__count');
    if (countEl) countEl.textContent = visibleCount + '\u00A0ITEMS';

    /* show empty state if no cards */
    let emptyEl = grid.querySelector('.cl-grid__empty--js');
    if (visibleCount === 0) {
      if (!emptyEl) {
        emptyEl = document.createElement('div');
        emptyEl.className = 'cl-grid__empty cl-grid__empty--js';
        emptyEl.innerHTML = '<p>NO PRODUCTS MATCH YOUR FILTERS.</p><button class="cl-empty-link" id="cl-clear-filters">CLEAR FILTERS</button>';
        grid.appendChild(emptyEl);
        document.getElementById('cl-clear-filters') &&
          document.getElementById('cl-clear-filters').addEventListener('click', clearFilters);
      }
    } else if (emptyEl) {
      emptyEl.remove();
    }
  }

  /* ── CLEAR ALL FILTERS ────────────────────────────────────────────────── */
  function clearFilters() {
    document.querySelectorAll('.cl-filter-check:checked').forEach((cb) => (cb.checked = false));
    if (priceMin) priceMin.value = '';
    if (priceMax) priceMax.value = '';
    state.availability = [];
    state.tags = [];
    state.vendors = [];
    state.dropLabels = [];
    state.priceMin = null;
    state.priceMax = null;
    applyFilters();
  }

  /* ── INIT ─────────────────────────────────────────────────────────────── */
  // Restore filter UI state from URL params (for page refresh persistence)
  (function initFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const sortVal = params.get('sort_by');
    if (sortVal && sortSelect) {
      sortSelect.value = sortVal;
    }
  })();

  // Set correct aria-expanded on filter groups on load
  document.querySelectorAll('[data-filter-group]').forEach((group) => {
    const btn  = group.querySelector('[data-filter-toggle]');
    const body = btn && btn.nextElementSibling;
    if (btn && body) {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      if (!expanded) body.setAttribute('hidden', '');
    }
  });

})();
